import { useQuery } from 'react-query'
import { DetailPaginatedRequest } from '../../../core/interfaces'
import { getContractItems } from '../../contracts'

export default function useContractItems(query: DetailPaginatedRequest) {
  const { data, error, isLoading } = useQuery(['contractItems', query], () =>
    getContractItems(query)
  )
  return { data, error, isLoading }
}
